<template>
  <div>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<style>
</style>
<script>


export default {
  name: "generalTemplate",
  data () {
    return {

    }
  },
  methods: {

  }

}
</script>

<style>

body {
  width: 100%;
  height: 100%;
}
</style>
